import Icon from 'veui/components/Icon'
import { IconItalic } from 'dls-icons-vue'

Icon.register('italic', IconItalic)
